// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1cKNM","header":"ReportDetails_header__EtpoO","title":"ReportDetails_title__2Scps","left":"ReportDetails_left__LtHgF"};